'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, pid) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      pid: pid

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/participants/' + pid
      },
      types: ['GET_PARTICIPANT_START', 'GET_PARTICIPANT', 'GET_PARTICIPANT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getEventRegistrationForPerson.js
// module id = 636
// module chunks = 0